/** @type {ActionType} */
export const pbr_experiments_succeeded = 'pbr_experiments_succeeded';

/** @type {ActionType} */
export const pbr_experiments_request_failed = 'pbr_experiments_request_failed';
